import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { ScrollArea } from '@mantine/core';

var _excluded = ["style"];
var SelectScrollArea = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var style = _ref.style,
    others = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(ScrollArea, _objectSpread2(_objectSpread2({}, others), {}, {
    style: _objectSpread2({
      width: '100%'
    }, style),
    viewportRef: ref
  }), others.children);
});

export { SelectScrollArea };
//# sourceMappingURL=SelectScrollArea.js.map
